<template>
  <div style="height: 100%;">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
/* 确保根元素和容器高度为100% */
html,
body,
#app {
  height: 100%;
  min-width: 1400px;
  margin: 0;
  padding: 0;
  background-color: rgba(255, 255, 255, 1);
}

/* router-view容器样式 */
.router-view-container {
  height: 100vh;
  /* 或使用 min-height: 100% */
  width: 100vw;
}

* {
  box-sizing: border-box;
  /* 所有元素默认使用 border-box 设置盒模型：元素的实际宽度 = width（包含 padding 和 border）*/
}
</style>
